/**
 * Welche Wechsel in diesem Clip liegen.
 *
 * `rand` hält Abstand zu Anfang und Ende: ein Wechsel im ersten Zehntel
 * ergäbe ein Stück, das kürzer ist als ein Wimpernschlag. Dieselbe Regel
 * greift zwischen zwei Wechseln -- ein Blitzlicht ist kein Schnitt.
 */
export function szenenImClip(schnitte, clip, rand = 0.4) {
    const tempo = clip.speed > 0 ? clip.speed : 1;
    const ende = clip.sourceIn + clip.duration * tempo;
    const raus = [];
    let zuletzt = clip.sourceIn;
    for (const quelle of [...schnitte].sort((a, b) => a - b)) {
        if (quelle <= clip.sourceIn || quelle >= ende)
            continue;
        // Abstand in der Zeit des Schnitts messen und nicht in der der Datei:
        // bei doppeltem Tempo ist eine Sekunde Datei eine halbe im Film.
        if ((quelle - zuletzt) / tempo < rand)
            continue;
        if ((ende - quelle) / tempo < rand)
            continue;
        raus.push({ quelle, bei: clip.start + (quelle - clip.sourceIn) / tempo });
        zuletzt = quelle;
    }
    return raus;
}
/**
 * Der Clip in seine Einstellungen zerlegt: lückenlos hintereinander, an
 * derselben Stelle, in derselben Reihenfolge. Nichts fällt weg -- anders als
 * bei den Pausen, wo genau das der Zweck ist.
 */
export function anSzenen(clip, schnitte, rand = 0.4) {
    const stellen = szenenImClip(schnitte, clip, rand);
    if (stellen.length === 0)
        return [];
    const tempo = clip.speed > 0 ? clip.speed : 1;
    const ende = clip.sourceIn + clip.duration * tempo;
    const r = (v) => Math.round(v * 1000) / 1000;
    const grenzen = [clip.sourceIn, ...stellen.map((s) => s.quelle), ende];
    const stuecke = [];
    let start = clip.start;
    for (let i = 0; i < grenzen.length - 1; i++) {
        const dauer = (grenzen[i + 1] - grenzen[i]) / tempo;
        stuecke.push({ start: r(start), duration: r(dauer), sourceIn: r(grenzen[i]) });
        start += dauer;
    }
    return stuecke;
}
//# sourceMappingURL=szenen.js.map